import { useState, useEffect, useReducer } from 'react';
import axios from 'axios';
import { getTokenCookie, setTokenCookie } from './session';

const urlApi = process.env.REACT_APP_API_ENDPOINT + "api/"
const tenantId = window.location.host.split(':')[0].split('.')[0];

const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_INIT':
      return {
        ...state,
        isLoadingList: true,
        isErrorGetList: false,
      };
    case 'FETCH_SUCCESS':
      return {
        ...state,
        isLoadingList: false,
        isErrorGetList: false,
        list: action.dataload,
      };
    case 'FETCH_FAILURE':
      return {
        ...state,
        isLoadingList: false,
        isErrorGetList: true,
      };
    default:
      throw new Error();
  }
};

const useGetApi = (endpoint) => {      
     
    const [listAtualiza, setListAtualiza] = useState([]);

    const [state, dispatch] = useReducer(dataFetchReducer, {
      isLoadingList: false,
      isErrorGetList: false,
      list: [],
    });

    useEffect(() => {
      const source = axios.CancelToken.source();
            
      const fetchData = async () => {

        var token = getTokenCookie();

        if(token === null || (token != null && token.expiration === null)){
          token.expired = true;
          setTokenCookie(token)
          window.location.reload();
          return; 
        }
        var now = new Date();
        var expiration = new Date(token.expiration);
        
        if (expiration < now)
        {
          token.expired = true;
          setTokenCookie(token)
          window.location.reload();
          return;      
        }

        dispatch({ type: 'FETCH_INIT' });
        
        try {
          const urlComplete = urlApi+endpoint;
          const config = {
            headers: {
              'Content-Type': 'application/json', 
              'Authorization': `Bearer ${token.accessToken}`,
              'tenantId': tenantId,
            },
          };
          //const result = await axios(urlComplete, { cancelToken: source.token }, headers);
          const result = await axios(urlComplete, config);     
          dispatch({ type: 'FETCH_SUCCESS', dataload: result.data });                           
        } catch (error) {
          if (error.response.status === 401 || error.response.status === 403){
            token.expired = true;
            setTokenCookie(token)
            window.location.reload();
            return;   
          } 
          if (axios.isCancel(error)) {
            // request cancelled
          } else {
            dispatch({ type: 'FETCH_FAILURE' });
          }
        }
      };

      if(listAtualiza.length>0){            
          dispatch({ type: 'FETCH_SUCCESS', dataload: listAtualiza });
      }
      else{  
        fetchData();
      }
      
      return () => {
        source.cancel();
      };
    
    }, [listAtualiza]);

    return [state,setListAtualiza];
};

const UsePostApi = (endpoint, obj) => {
  var token = getTokenCookie();
    
  if(token === null){
    let _token = {expired:true};
    setTokenCookie(_token)
    window.location.reload();
    return; 
  }
  var now = new Date();
  var expiration = new Date(token.expiration);
  if (expiration < now)
  {
    token.expired = true;
    setTokenCookie(token)
    window.location.reload();
    return;      
  }
  
  try 
  {
    const urlComplete = urlApi+endpoint;
    const config = {
      headers: {
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token.accessToken}`,
        'tenantId': tenantId,
      },
    };
    return axios.post(urlComplete, obj, config)
    .then(result => {    
      var newResult = {
        status: result.status,
        message: "Cadastro realizado com sucesso!",
        data: result.data,
        headers: result.headers
      }   
      return newResult;
    })
    .catch(function (error) {
      if (error.response) {     
        if (error.response.status === 401 || error.response.status === 403){
          token.expired = true;
          setTokenCookie(token)
          window.location.reload();
          return;   
        }    
        
        var message = "";
        if(error.response.data)
          message = error.response.data;
        else
          message = "Erro inesperado. (" + endpoint + ")"

        var newError = {
          status: error.response.data.status,
          message:message
        }   
        return newError;
      }
      else
      {
        var result = {
          status: 500,
          message:"Erro ao conectar com api. (" + endpoint + ")"
        }           
        return result;
      } 
    });
    
  } catch (error) {
    var result = {
      status: 500,
      message:"Erro ao tentar inserir os dados."
    }      
    return result;
  }    
};

const UsePostApiFile = (endpoint, obj) => {          
  var token = getTokenCookie();
  
  if(token === null || (token != null && token.expiration === null)){
    token.expired = true;
    setTokenCookie(token)
    window.location.reload();
    return; 
  }
  var now = new Date();
  var expiration = new Date(token.expiration);
  if (expiration < now)
  {
    token.expired = true;
    setTokenCookie(token)
    window.location.reload();
    return;      
  }
  
  try 
  {
    const urlComplete = urlApi+endpoint;
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data', 
        'Authorization': `Bearer ${token.accessToken}`,
        'tenantId': tenantId,
      },
    };
    return axios.post(urlComplete, obj, config)
    .then(result => {    
     var newResult = {
        status: result.status,
        message: "Importação realizada com sucesso!",
        data: result.data,
        headers: result.headers
      }   
      return newResult;
    })
    .catch(function (error) {
      if (error.response) {     
        if (error.response.status === 401 || error.response.status === 403){
          token.expired = true;
          setTokenCookie(token)
          window.location.reload();
          return;   
        }    
        
        var message = "";
        
        if(error.response.data.message)
          message = error.response.data.message;
        else
          message = "Erro inesperado. (" + endpoint + ")"

        var newError = {
          status: error.response.data.status,
          message:message
        }   
        return newError;
      }
      else
      {
        var result = {
          status: 500,
          message:"Erro ao conectar com api. (" + endpoint + ")"
        }           
        return result;
      } 
    });
    
  } catch (error) {
    var result = {
      status: 500,
      message:"Erro ao tentar inserir os dados."
    }      
    return result;
  }    
};

const UsePostApiLogin = (endpoint, obj) => {
  try 
  {
    const urlComplete = urlApi + endpoint;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'tenantId': tenantId,
      },
    };
    return axios.post(urlComplete, obj, config)
    .then(result => {
     var newResult = {
        status: result.status,
        message: "Cadastro realizado com sucesso!",
        data: result.data,
        headers: result.headers
      }   
      return newResult;
    })
    .catch(function (error) {
      if (error.response) {           
        var message = "";
        if(error.response.data.message)
          message = error.response.data.message;
        else
          message = "Erro inesperado. (" + endpoint + ")"

        var newError = {
          status: error.response.data.status,
          message:message
        }   
        return newError;
      }
      else
      {
        var result = {
          status: 500,
          message:"Erro ao conectar com api. (" + endpoint + ")"
        }           
        return result;
      } 
    });
    
  } catch (error) {
    var result = {
      status: 500,
      message:"Erro ao tentar inserir os dados."
    }      
    return result;
  }    
};

const UsePutApi = (endpoint, id, obj) => {  
    var token = getTokenCookie();
    
    if(token === null || (token != null && token.expiration === null)){
      token.expired = true;
      setTokenCookie(token)
      window.location.reload();
      return; 
    }
    var now = new Date();
    var expiration = new Date(token.expiration);
    if (expiration < now)
    {
      token.expired = true;
      setTokenCookie(token)
      window.location.reload();
      return;      
    }

    try 
    {
      const urlComplete = urlApi+endpoint+id;
      const headers = {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token.accessToken}`,
          'tenantId': tenantId,
        }};
      return axios.put(urlComplete,obj,headers)
      .then(result => {
        if(result.data.status)
        {
          let newResult = {
            status: result.data.status,
            message: result.data.message
          }  
          return newResult;
        }
        else{
          let newResult = {
            status: result.status,
            message: "Dados atualizados com sucesso!",
            data: result.data,
          }  
          return newResult;
        }
      })
      .catch(function (error) {
        if (error.response) {  
          if (error.response.status === 401 || error.response.status === 403){
            token.expired = true;
            setTokenCookie(token)
            window.location.reload();
            return;   
          }
      
          let messageError = "";          
          if(error.response.data) {
            if (typeof error.response.data === "string") {
              messageError = error.response.data;
            } else if (error.response.data.message) {
              messageError = error.response.data.message;
            } else {
              messageError = JSON.stringify(error.response.data);
            }
          }
      
          let newError = {
            status: error.response.data.status,
            message: messageError
          };   
          return newError;
        } 
      });
      
    } 
    catch (error) 
    {
      let result = {
        status: 500,
        message:"Erro ao tentar alterar os dados."
      }      
      return result;
    }
};

const UsePutApiRaw = (endpoint, id, obj) => {
    var token = getTokenCookie();

    if(token === null || (token != null && token.expiration === null)){
      token.expired = true;
      setTokenCookie(token)
      window.location.reload();
      return;
    }
    var now = new Date();
    var expiration = new Date(token.expiration);
    if (expiration < now)
    {
      token.expired = true;
      setTokenCookie(token)
      window.location.reload();
      return;
    }

    try
    {
      const urlComplete = urlApi+endpoint+id;
      const headers = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token.accessToken}`,
          'tenantId': tenantId,
        }};
      return axios.put(urlComplete,obj,headers)
      .then(result => {
        let newResult = {
          status: result.status,
          message: "Dados atualizados com sucesso!",
          data: result.data,
        }
        return newResult;
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403){
            token.expired = true;
            setTokenCookie(token)
            window.location.reload();
            return;
          }

          let messageError = "";
          if(error.response.data) {
            if (typeof error.response.data === "string") {
              messageError = error.response.data;
            } else if (error.response.data.message) {
              messageError = error.response.data.message;
            } else {
              messageError = JSON.stringify(error.response.data);
            }
          }

          let newError = {
            status: error.response.status,
            message: messageError
          };
          return newError;
        }
      });

    }
    catch (error)
    {
      let result = {
        status: 500,
        message:"Erro ao tentar alterar os dados."
      }
      return result;
    }
};

const UsePutApiAnonymous = (endpoint, id, obj) => {

  try 
  {
    const urlComplete = urlApi+endpoint+id; 
    const headers = {headers: {
      'Content-Type': 'application/json',
      'tenantId': tenantId,
    }};
    return axios.put(urlComplete,obj, headers)
    .then(result => {                
      if(result.data.status)
      {
        let newResult = {
          status: result.data.status,
          message: result.data.message
        }  
        return newResult;
      }
      else{
        let newResult = {
          status: result.status,
          message: "Dados atualizados com sucesso!",
          data: result.data,
        }  
        return newResult;
      }
    })
    .catch(function (error) {
      if (error.response) {  

        let messageError = "";          
        if(error.response.data.message)
          messageError = error.response.data.message
        else if(error.response.data.title)
          messageError = error.response.data.title

        let newError = {
          status: error.response.data.status,
          message:messageError  
        }   
        return newError;
      } 
    });
    
  } catch (error) {
    let result = {
      status: 500,
      message:"Erro ao tentar alterar os dados."
    }      
    return result;
  }    
};

const UseDeleteApi = (endpoint, id, userDeletadoid, estabelecimentoId = null) => {      
    var token = getTokenCookie();
    
    if(token === null || (token != null && token.expiration === null)){
      token.expired = true;
      setTokenCookie(token)
      window.location.reload();
      return; 
    }
    var now = new Date();
    var expiration = new Date(token.expiration);
    if (expiration < now)
    {
      token.expired = true;
      setTokenCookie(token)
      window.location.reload();
      return;      
    }
    try 
    {
      let urlComplete = urlApi + endpoint + id + "/" + userDeletadoid;
      if (estabelecimentoId !== null) 
      {
        urlComplete += "/" + estabelecimentoId;
      }
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token.accessToken}`,
          'tenantId': tenantId,
        },
      };
      return axios.delete(urlComplete, config)
      .then(result => {        
        let newResult = {
          status: result.status,
          message:"Alteração realizada com sucesso!",
          data: result.data
        }  
        return newResult;
      })
      .catch(function (error) {
        if (error.response) {       
          if (error.response.status === 401 || error.response.status === 403){
            token.expired = true;
            setTokenCookie(token)
            window.location.reload();
            return;   
          }

          let newError = {
            status: error.response.data.status,
            message:error.response.data.message
          }   
          return newError;
        } 
      });  
      
    } catch (error) {
      let result = {
        status: 500,
        message:"Erro ao deletar registro."
      }           
      return result;
    }    
};

const UseGetApiSimple = (endpoint) => {          
    var token = getTokenCookie();

    if (token === null) {
      let _token = {expired:true};
      setTokenCookie(_token)
      window.location.reload();
      return;       
    }
    
    if(token === null || (token != null && token.expiration === null)){
      token.expired = true;
      setTokenCookie(token)
      window.location.reload();
      return; 
    }
    var now = new Date();
    var expiration = new Date(token.expiration);
    if (expiration < now)
    {
      token.expired = true;
      setTokenCookie(token)
      window.location.reload();
      return;      
    }
    try 
    {
      const urlComplete = urlApi+endpoint;                              
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token.accessToken}`,
          'tenantId': tenantId,
        },
      };
      return axios.get(urlComplete, config)
      .then(result => {          
        let newResult = {
          status: result.status,
          data: result.data,
          headers: result.headers
        }  
        return newResult;
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403){
            token.expired = true;
            setTokenCookie(token)
            window.location.reload();
            return;   
          }
          
          let message = "";
          if(error.response.data.message)
            message = error.response.data.message;
          else
            message = "Erro inesperado. (" + endpoint + ")"

          let newError = {
            status: error.response.data.status,
            message:message
          }   
          return newError;
        }
        else
        {
          let result = {
            status: 500,
            message:"Erro ao conectar com api. (" + endpoint + ")"
          }           
          return result;
        } 
      });
    } 
    catch (error) {
      let result = {
        status: 500,
        message:"Erro ao deletar registro."
      }           
      return result;
    }
};

const UseGetApiendPointDiferent = (endpoint) => {
  var token = getTokenCookie();
  if(token === null || (token != null && token.expiration === null)){
    token.expired = true;
    setTokenCookie(token)
    window.location.reload();
    return; 
  }
  var now = new Date();
  var expiration = new Date(token.expiration);
  if (expiration < now)
  {
    token.expired = true;
    setTokenCookie(token)
    window.location.reload();
    return;      
  }

  try 
  {
      return axios(endpoint)
      .then(result => {        
        var newResult = {
          status: result.status,
          data: result.data
        }  
        return newResult;
      })
      .catch(function (error) {
        if (error.response) {       
          if (error.response.status === 401 || error.response.status === 403){
            token.expired = true;
            setTokenCookie(token)
            window.location.reload();
            return;   
          }

          var message = "";
          if(error.response.data.message)
            message = error.response.data.message;
          else
            message = "Erro inesperado. (" + endpoint + ")"

          var newError = {
            status: error.response.data.status,
            message:message
          }   
          return newError;
        }
        else
        {
          var result = {
            status: 500,
            message:"Erro ao conectar com api. (" + endpoint + ")"
          }           
          return result;
        } 
      });
    
  } catch (error) {
    var result = {
      status: 500,
      message:"Erro ao deletar registro."
    }           
    return result;
  }  
};

const UsePutApiSimple = (endpoint) => {
    try 
    {
      const urlComplete = urlApi+endpoint;
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'tenantId': tenantId,
        },
      };
      return axios.put(urlComplete, config)
      .then(result => {                
        var newResult = {
          status: result.data.status,
          message: result.data.message
        }  
        return newResult;
      })
      .catch(function (error) {
        if (error.response) {   
               
          var newError = {
            status: error.response.data.status,
            message:error.response.data.message
          } 
          return newError;
        } 
      });
      
    } catch (error) {
      var result = {
        status: 500,
        message:"Erro ao tentar alterar os dados."
      }      
      return result;
    }   
};

const UseGetApiSimpleAnonymous = (endpoint) => {
  try 
  {
      const urlComplete = urlApi+endpoint;
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'tenantId': tenantId,
        },
      };
      return axios.get(urlComplete, config)
      .then(result => {          
        var newResult = {
          status: result.status,
          data: result.data,
          headers: result.headers
        }  
        return newResult;
      })
      .catch(function (error) {
        if (error.response) {
          
          var message = "";
          if(error.response.data.message)
            message = error.response.data.message;
          else
            message = "Erro inesperado. (" + endpoint + ")"

          var newError = {
            status: error.response.data.status,
            message:message
          }   
          return newError;
        }
        else
        {
          var result = {
            status: 500,
            message:"Erro ao conectar com api. (" + endpoint + ")"
          }           
          return result;
        } 
      });
    
  } catch (error) {
    var result = {
      status: 500,
      message:"Erro ao deletar registro."
    }           
    return result;
  }  
};

export {
useGetApi,
UsePostApi,
UsePostApiFile,
UsePostApiLogin,
UsePutApi,
UsePutApiRaw,
UsePutApiAnonymous,
UseDeleteApi,
UseGetApiSimple,
UsePutApiSimple,
UseGetApiendPointDiferent,
UseGetApiSimpleAnonymous};
